// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  SLIDE: '[data-fragment="ImageProjector.slide"]',
};

class ImageProjector extends WebComponent {
  constructor(props) {
    super(props);
    this.isOpen = false;
    this.nextSlide = this.nextSlide.bind(this);
    this.startProjection = this.startProjection.bind(this);
  }

  didMount() {
    this.slides = [...this.element.querySelectorAll(fragments.SLIDE)];
    console.log(this.slides);
    console.log(this.slides);

    this.startProjection();
  }

  nextSlide() {
    const activeSlide = this.slides.find((slide) => slide.classList.contains(this.props.activeClass));
    const nextSlide = activeSlide.nextElementSibling || this.slides[0];


    // Zobraz další slide
    nextSlide.classList.add(this.props.visibleClass);
    setTimeout(() => {
      nextSlide.classList.add(this.props.activeClass);
    }, 10)

    // Skryj aktuální slide
    activeSlide.classList.remove(this.props.activeClass);
    activeSlide.classList.remove(this.props.visibleClass);
    activeSlide.classList.add(this.props.exitingClass);
    setTimeout(() => {
      activeSlide.classList.remove(this.props.exitingClass);
    }, this.props.transitionDurationMs)

  }

  startProjection() {
    if (this.slides.length >= 2) {
      setInterval(this.nextSlide, this.props.transitionIntervalMs);
    }

  }
}


ImageProjector.defaultProps = {
  activeClass: 'campfire-slider__figure--active',
  visibleClass: 'campfire-slider__figure--visible',
  exitingClass: 'campfire-slider__figure--exiting',
  transitionDurationMs: 1000,
  transitionIntervalMs: 6000,
}

export default ImageProjector;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ImageProjector.js